<script lang="ts">
    let { block }: { block: Block<"externalLinks"> } = $props()
</script>

<ul>
    {#each block.content.links as { url, title, type }}
        <li>
            <a href={url} target="_blank">
                <span>
                    {#if type == "other"}
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.4999 7.875C10.2678 7.875 10.0453 7.78281 9.88118 7.61872C9.71709 7.45462 9.6249 7.23206 9.6249 7C9.6249 6.76794 9.71709 6.54538 9.88118 6.38128C10.0453 6.21719 10.2678 6.125 10.4999 6.125H20.9999C21.232 6.125 21.4545 6.21719 21.6186 6.38128C21.7827 6.54538 21.8749 6.76794 21.8749 7V17.5C21.8749 17.7321 21.7827 17.9546 21.6186 18.1187C21.4545 18.2828 21.232 18.375 20.9999 18.375C20.7678 18.375 20.5453 18.2828 20.3812 18.1187C20.2171 17.9546 20.1249 17.7321 20.1249 17.5V9.11167L7.61824 21.6183C7.45237 21.7729 7.23298 21.857 7.00629 21.853C6.77961 21.849 6.56333 21.7572 6.40301 21.5969C6.24269 21.4366 6.15086 21.2203 6.14686 20.9936C6.14287 20.7669 6.22701 20.5475 6.38157 20.3817L18.8882 7.875H10.4999Z"
                                fill="#242220"
                            ></path>
                        </svg>
                    {:else}
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M23.625 9.33333C23.625 8.0183 23.1022 6.7575 22.1724 5.82764C21.2425 4.89777 19.9817 4.375 18.6667 4.375H9.33333C8.0183 4.375 6.7575 4.89777 5.82764 5.82764C4.89777 6.7575 4.375 8.0183 4.375 9.33333V18.6667C4.375 19.9817 4.89777 21.2425 5.82764 22.1724C6.7575 23.1022 8.0183 23.625 9.33333 23.625H18.6667C19.9817 23.625 21.2425 23.1022 22.1724 22.1724C23.1022 21.2425 23.625 19.9817 23.625 18.6667V9.33333ZM7.29167 19.8333V11.6667C7.29167 11.1834 7.68342 10.7917 8.16667 10.7917C8.64992 10.7917 9.04167 11.1834 9.04167 11.6667V19.8333C9.04167 20.3166 8.64992 20.7083 8.16667 20.7083C7.68342 20.7083 7.29167 20.3166 7.29167 19.8333ZM18.9583 19.8333V16.0417C18.9583 15.2058 18.6344 14.6324 18.179 14.2529C17.7036 13.8568 17.0364 13.6354 16.3333 13.6354C15.6302 13.6354 14.9631 13.8568 14.4876 14.2529C14.0323 14.6324 13.7083 15.2058 13.7083 16.0417V19.8333C13.7083 20.3166 13.3166 20.7083 12.8333 20.7083C12.3501 20.7083 11.9583 20.3166 11.9583 19.8333V11.6667C11.9583 11.1834 12.3501 10.7917 12.8333 10.7917C13.3166 10.7917 13.7083 11.1834 13.7083 11.6667V12.6533C14.4874 12.1313 15.4238 11.8854 16.3333 11.8854C17.3801 11.8854 18.4631 12.211 19.3001 12.9085C20.1571 13.6228 20.7083 14.6902 20.7083 16.0417V19.8333C20.7083 20.3166 20.3166 20.7083 19.8333 20.7083C19.3501 20.7083 18.9583 20.3166 18.9583 19.8333ZM8.8138 8.76709C8.48871 9.12442 7.93513 9.1513 7.57764 8.82633C7.22009 8.50129 7.19454 7.94775 7.51953 7.59017L8.8138 8.76709ZM7.53092 7.5765C7.85602 7.21915 8.4096 7.1934 8.76709 7.51839C9.12441 7.84349 9.15131 8.39707 8.82633 8.75456L8.8138 8.76709L7.51953 7.59017L7.53092 7.5765ZM25.375 18.6667C25.375 20.4458 24.6677 22.1516 23.4097 23.4097C22.1516 24.6677 20.4458 25.375 18.6667 25.375H9.33333C7.55417 25.375 5.84839 24.6677 4.59033 23.4097C3.33228 22.1516 2.625 20.4458 2.625 18.6667V9.33333C2.625 7.55417 3.33228 5.84839 4.59033 4.59033C5.84839 3.33228 7.55417 2.625 9.33333 2.625H18.6667C20.4458 2.625 22.1516 3.33228 23.4097 4.59033C24.6677 5.84839 25.375 7.55417 25.375 9.33333V18.6667Z"
                                fill="#242220"
                            ></path>
                        </svg>
                    {/if}
                </span>
                <span>{title}</span>
            </a>
        </li>
    {/each}
</ul>

<style lang="less">
    ul {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;

        li,
        a {
            display: flex;
            align-items: flex-start;
            gap: 0.6rem;
            span {
                display: flex;
                align-items: center;
                gap: 0.6rem;
            }
            svg path {
                transition: 0.3s fill ease-in-out;
            }
            &:hover {
                svg path {
                    fill: var(--brand-100);
                }
            }
        }
    }
</style>
